import { render, staticRenderFns } from "./dubber.vue?vue&type=template&id=4a65b34a"
import script from "./dubber.vue?vue&type=script&lang=js"
export * from "./dubber.vue?vue&type=script&lang=js"
import style0 from "./dubber.vue?vue&type=style&index=0&id=4a65b34a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports